export default __webpack_public_path__ + "content/media/8.e092fdcc.jpg";